import React, {useState} from 'react';

import styles from './Filters.module.css'

import {FilterSchema, FilterType} from "./types/filterSchema.interface.tsx";
import {useScreenDetector} from "../../hooks/useScreenDetector.ts";
import {DrawerMobile} from "../Feedback/Drawer/DrawerMobile.tsx";
import {CheckboxSchemaTemplate} from "./components/Checkbox/template/CheckboxSchemaTemplate.tsx";
import {Button} from "../General/Button/Button.tsx";
import {cn} from "../../utils/cn.ts";

interface Props {
    setIds: (ids: number[]) => void,
    onFiltersApply: () => void,
    clearFilter: () => void,
    schema: FilterSchema[],
    showButton: boolean,
}

export const Filters: React.FC<Props> = ({schema, setIds, onFiltersApply, showButton, clearFilter,}) => {
    const {isMobile, isDesktop } = useScreenDetector()
    const [closeFilter, setCloseFilter] = useState(false);

    const changeIds = (ids: number[]) => {
        setIds(ids);
        onFiltersApply();
    }

    return (<>
        {isDesktop && <div className={styles.wrapper} id="filter">
            {schema.map((schema) => (<>
                {FilterType.checkbox === schema.type && (<>
                    <CheckboxSchemaTemplate
                        label={schema.label}
                        values={schema.values.sort((a, b) => {
                            if(a.name > b.name) return 1;
                            else if(a.name < b.name) return -1;
                            else return 0;
                        })}
                        setIds={changeIds}
                    />
                    {
                        showButton
                        ? <div>
                            <Button
                                type='regular'
                                className={styles.desktopBtn}
                                onClick={() => {
                                    onFiltersApply();
                                }}
                            >
                                Применить
                            </Button>
                            <Button
                                type='regular'
                                className={cn(styles.desktopBtn, styles.btnClear)}
                                onClick={() => {
                                    setIds([]);
                                    clearFilter();
                                }}
                            >
                                Сбросить
                            </Button>
                        </div>
                        : null
                    }
                </>)}
            </>))}
        </div>}

        {isMobile && (
            <DrawerMobile title='Фильтр' closeFilter={closeFilter} setCloseFilter={setCloseFilter}>
                <div>
                    <div className={styles.filters} id="filter">
                        {schema.map((schema) => (<>
                            {FilterType.checkbox === schema.type && (<>
                                <CheckboxSchemaTemplate
                                    label={schema.label}
                                    values={schema.values.sort((a, b) => {
                                        if(a.name > b.name) return 1;
                                        else if(a.name < b.name) return -1;
                                        else return 0;
                                    })}
                                    setIds={changeIds}
                                />
                            </>)}
                        </>))}
                    </div>
                    <div className={styles.buttons} style={{marginTop: 12,}}>
                        <Button
                            type='regular'
                            className={styles.btn}
                            onClick={() => {
                                onFiltersApply();
                                setCloseFilter(true)
                            }}
                        >
                            Применить
                        </Button>
                        <Button
                            type='regular'
                            className={cn(styles.btn, styles.btnClear)}
                            onClick={() => {
                                setIds([]);
                                clearFilter();
                            }}
                        >
                            Сбросить
                        </Button>
                    </div>
                </div>
            </DrawerMobile>
        )}
    </>);
};